import { DateRange } from "./unifiedInventoryMovementInterfaces"

export interface SelectComponent {
    label?: string,
    value?: string
}

export interface InventoryMonitoringGraphVisualisationRequest {
    searchCriteria? : Query,
    aggregationCriteriaList? : InventoryMonitoringAggregationCriteria,
    rangeCriteria? : InventoryMonitoringRangeCriteria
}

export interface InventoryMonitoringGraphVisualisationResponse {
    data: MonitoringGraphDataType[]
}

export interface InventoryMonitoringTrendsVisualisationResponse {
    data: MonitoringTrendsDataType[]
}

export interface MonitoringGraphDataType {
    type: string
    views: Attributes[]
}

export interface MonitoringTrendsDataType {
    type: string
    views: TrendsViewList[]
}

export interface Attributes{
    key: string,
    value?: string,
    subAttribute?: Attributes
}

export interface TrendsViewList{
    name: string,
    values: TimeSeriesList[]
}

export interface TimeSeriesList{
    x: string,
    y: number
}

export interface Query {
	andQuery?: Query[],
	orQuery?: Query[],
	comparatorQuery?: ComparatorQuery
}

export interface ComparatorQuery {
	field: String,
	comparator: SearchType,
	value?: SearchValue
}

export interface SearchValue {
	dataType: String,
	value: String,
	rangeValue?: RangeValue
    valueList?: String[]
}

export interface RangeValue {
	inclusiveStartValue: String,
	inclusiveEndValue: String
}

export interface ConsumptionPreferenceRequest {
	searchCriteria?: Query,
    viewType?: InventoryMonitoringPortalViewType,
    aggregationCriteriaList?: InventoryMonitoringAggregationCriteria[]
    rangeCriteria?: InventoryMonitoringRangeCriteria,
    sortCriteria?: InventoryMonitoringSortCriterion,
    maxResults?: number,
    nextToken?: String
	paginationType: PaginationType,
}

export interface InventoryMonitoringRangeCriteria {
    from: number,
    to: number,
    timeInterval?: TimeInterval
}

export interface InventoryMonitoringSortCriterion {
    field: String,
    order: SortOrder
}

export interface InventoryMonitoringAggregationCriteria {
    name: String,
    typeCriteria?: TypeCriteria
    aggregation?: InventoryMonitoringAggregationCriteria
    aggregationCriteriaList?: InventoryMonitoringAggregationCriteria[]
}

export interface TypeCriteria {
    type: InventoryMonitoringAggregationOperationCriteria,
    field: String
    size?: number,
    order?: SortOrder
    afterKey?: String
}

export interface InventoryMonitoringAggregationOperationCriteria {
    operation?: AggregationOperation,
    subOperation?: AggregationSubOperation
}

export enum SearchType {
	EXACT_MATCH = "EXACT_MATCH",
    NESTED = "NESTED",
    CONTAINS = "CONTAINS",
	RANGE = "RANGE",
	PREFIX_MATCH = "PREFIX_MATCH",
	NOT_MATCH = "NOT_MATCH",
    TERMS = "TERMS"
}

export enum InventoryMonitoringPortalViewType {
	AGGREGATED_CONSUMPTION_DATA = "AGGREGATED_CONSUMPTION_DATA",
    HISTORICAL_QUANTITY_CONSUMPTION_DATA = "HISTORICAL_QUANTITY_CONSUMPTION_DATA",
    SUPERSET_PREFERENCE_EXPIRY_DATA = "SUPERSET_PREFERENCE_EXPIRY_DATA" 
}

export enum AggregationOperation {
    TERMS = "TERMS",
    PERCENTILES = "PERCENTILES",
    SUM = "SUM",
    AVERAGE = "AVERAGE",
    DATE_HISTOGRAM = "DATE_HISTOGRAM",
    BUCKET_SORT = "BUCKET_SORT",
    COMPOSITE = "COMPOSITE",
    FILTER = "FILTER",
    NESTED = "NESTED"
}

export enum AggregationSubOperation {
    P50 = "P50",
    P90 = "P90",
    TERMS = "TERMS"
}

export enum SortOrder {
    ASC = "ASC",
    DESC = "DESC"
}

export enum TimeInterval {
    DEFAULT = "DEFAULT",
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH"
}

export enum PaginationType {
    OFFSET_BASED = "OFFSET_BASED"
}

export interface ConsumptionPreferenceState {
    selectedGSM: string,
    currentTAM: string
    gsmOptions: SelectComponent[],
    isDropDownLoading: boolean,
    uatPreferences: any,
    sfgIdDropdownValues: any,
    preferenceDashboardTableData: any,
    allTableData: any,
    startTimeValue: any,
    selectedSfgId: any,
    showDateEditsModal: boolean,
    superSetId: string,
    selectedStartDate: any,
    selectedEndDate: any,
    isSfgDataUpdateInProgress: any,
    updatedStartDate: any,
    updatedEndDate: any,
    tamStartDate: any,
    tamEndDate: any,
    searchRequest: ConsumptionPreferenceRequest,
    sfgIdList: SelectComponent[],
    sfgDropdownList: SelectComponent[],
    sfgIdNameMapping: SelectComponent[],
    trendsViewSearchRequest: ConsumptionPreferenceRequest,
    trendsViewDateRange: DateRange,
    logicalGroupList: SelectComponent[],
    selectedLogicalGroup: any,
    logicalGroupDropdownValues: any,
    selectedIPN: any,
    IPNDropdownValues: any,
    selectedMonth: any,
    historicalQtyConsumptionTableData: any,
    historicalQtyConsumptionSearchRequest: ConsumptionPreferenceRequest,
    historicalQtyConsumptionPreference: any,
    updateComputedMonthsOptions: any
}